import {ref, computed, watch, onMounted} from 'vue'
import { HistoryFetchResult } from "../../fetch_history";

export function useSystemHistory(initialParams, fetchHistory) {
  const currentPage = ref(1)
  const loading = ref(true)
  const data = ref<HistoryFetchResult>(null)

  const params = ref({
    limit: 10,
    ...initialParams
  })

  const limit = computed(() => {
    return params.value.limit
  })

  const load = async () => {
    loading.value = true

    data.value = await fetchHistory({
      limit: limit.value,
      currentPage: currentPage.value,
      ...params.value
    })

    loading.value = false
  }

  const onParamsChange = async () => {
    await load()
  }

  const onPageChange = (newPage: number) => {
    currentPage.value = newPage
  }

  onMounted(async () => {
    await load()
  })

  watch([params, currentPage], onParamsChange, { deep: true })

  return {
    limit,
    currentPage,
    data,
    loading,
    onPageChange,
    params,
    load
  }
}